export const DEVICE_SHAPE_ENUM = {
  PC: "pc",
  MOBILE: "mobile"
};
